import {NgModule} from '@angular/core';
import {MaterialModule} from '../../../../shared/material/material.module';
import {
  CartegraphTasksComponent,
  CartegraphTasksDetailDialogComponent
} from './cartegraph-tasks/cartegraph-tasks.component';
import {
  CartegraphSettingsObservationsComponent
} from './cartegraph-observations/cartegraph-settings-observations.component';
import {RowWithToggleComponent} from '../row-with-toggle/row-with-toggle.component';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {CardContentDirective, CardContentRawDirective} from '../../../../shared/components/card/card-content.directive';
import {RowWithButtonComponent} from '../row-with-button/row-with-button.component';
import {ConfirmDeletionDialogComponent} from '../confirm-deletion-dialog/confirm-deletion-dialog.component';
import {UiBlockingLayerComponent} from '../ui-blocking-layer/ui-blocking-layer.component';
import {RowWithSelectComponent} from '../row-with-select/row-with-select.component';
import {ExpansionPanelComponent} from '../../../../shared/components/expansion-panel/expansion-panel.component';
import {
  CardEditableHeadingComponent
} from '../../../../shared/components/card-editable-heading/card-editable-heading.component';
import {CartegraphManagementRoutingModule} from './cartegraph-management-routing.module';
import {
  CartegraphTasksImportConfigDialogComponent,
  CartegraphTasksImportDialogComponent
} from './cartegraph-tasks-import/cartegraph-tasks-import-dialogs.component';
import {ManageCartegraphComponent} from './manage-cartegraph.component';
import {CartegraphHeaderComponent} from './cartegraph-header/cartegraph-header.component';
import {CartegraphMainSetupComponent} from './cartegraph-main-setup/cartegraph-main-setup.component';
import {CartegraphAccountComponent} from './cartegraph-account/cartegraph-account.component';
import {CartegraphTasksImportComponent} from './cartegraph-tasks-import/cartegraph-tasks-import.component';
import {CartegraphSettingsFeaturesComponent} from './cartegraph-features/cartegraph-settings-features.component';
import {
  CartegraphSettingsImportFiltersComponent
} from './cartegraph-import-filters/cartegraph-settings-import-filters.component';
import {
  CartegraphSettingsDefaultsObservationComponent
} from './cartegraph-defaults/cartegraph-settings-defaults-observation.component';
import {
  CartegraphSettingsDefaultsShiftComponent
} from './cartegraph-defaults/cartegraph-settings-defaults-shift.component';
import {CartegraphNotificationsComponent} from './cartegraph-notifications/cartegraph-settings-notifications.component';
import {CgTaskStatusUpdateDialog} from './cartegraph-tasks/cartegraph-tasks-status.copmponent';
import {
  CartegraphNotificationsAddDialogComponent
} from './cartegraph-notifications/cartegraph-settings-notifications-add.component';
import {
  CartegraphSettingsObservationsMappingComponent
} from './cartegraph-observations-mapping/cartegraph-settings-observations-mapping.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {
  ToggleExpansionPanelComponent
} from '../../../../shared/components/toggle-expansion-panel/toggle-expansion-panel.component';
import {
  CartegraphSettingsFeaturesMainComponent
} from './cartegraph-features/cartegraph-settings-features-main.component';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [CartegraphTasksDetailDialogComponent, CartegraphTasksImportDialogComponent, CartegraphTasksImportConfigDialogComponent],
  exports: [
    ManageCartegraphComponent,
    CartegraphManagementRoutingModule,
    CartegraphNotificationsAddDialogComponent,
    CartegraphSettingsObservationsMappingComponent,
    CartegraphHeaderComponent,
    CartegraphMainSetupComponent,
    CartegraphAccountComponent,
    CartegraphTasksComponent,
    CartegraphTasksImportComponent,
    CartegraphSettingsFeaturesMainComponent,
    CartegraphSettingsFeaturesComponent,
    CartegraphSettingsImportFiltersComponent,
    CartegraphSettingsDefaultsObservationComponent,
    CartegraphSettingsDefaultsShiftComponent,
    CartegraphSettingsObservationsComponent,
    CgTaskStatusUpdateDialog,
    CartegraphNotificationsComponent,
    CartegraphTasksDetailDialogComponent,
    CartegraphTasksImportDialogComponent,
    CartegraphTasksImportConfigDialogComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ToggleExpansionPanelComponent,
    MaterialModule,
    CardComponent,
    CardContentDirective,
    ConfirmDeletionDialogComponent,
    UiBlockingLayerComponent,
    RowWithButtonComponent,
    RowWithSelectComponent,
    RowWithToggleComponent,
    CardContentRawDirective,
    ExpansionPanelComponent,
    CardEditableHeadingComponent,
    ManageCartegraphComponent,
    CartegraphManagementRoutingModule,
    CartegraphNotificationsAddDialogComponent,
    CartegraphSettingsObservationsMappingComponent,
    CartegraphHeaderComponent,
    CartegraphMainSetupComponent,
    CartegraphAccountComponent,
    CartegraphTasksComponent,
    CartegraphTasksImportComponent,
    CartegraphSettingsFeaturesMainComponent,
    CartegraphSettingsFeaturesComponent,
    CartegraphSettingsImportFiltersComponent,
    CartegraphSettingsDefaultsObservationComponent,
    CartegraphSettingsDefaultsShiftComponent,
    CartegraphSettingsObservationsComponent,
    CgTaskStatusUpdateDialog,
    CartegraphNotificationsComponent,
    DatePipe,
  ],
})
export class CartegraphManagementModule {}
